import { Icon } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './Feature.styled';
export const Feature = ({ children }) => {
    return (React.createElement(S.Container, null,
        React.createElement(Icon, { component: TickIcon, height: 14 }),
        children));
};
